export const ApolloClientHeaders: Record<string, string> = {
};